import 'vue-googlemaps/dist/vue-googlemaps.css';
import VueGoogleMaps from 'vue-googlemaps';
import Vue from 'vue';

Vue.use(VueGoogleMaps, {
  load: {
    apiKey: process.env.GOOGLE_API_KEY || 'AIzaSyDkMlagTtdH8ygWX7x5bgGdVSzepFuXHpI',
    libraries: ['places'],
    useBetaRenderer: false,
  },
});
